
export default class GenericObject {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GenericObject.js